/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The type of the feature: privateNote (custom note), file (downloadable files), or licenseKey (license key).
 */
export const ProductFeatureType = {
  Custom: "custom",
  File: "file",
  LicenseKey: "licenseKey",
} as const;
/**
 * The type of the feature: privateNote (custom note), file (downloadable files), or licenseKey (license key).
 */
export type ProductFeatureType = ClosedEnum<typeof ProductFeatureType>;

/** @internal */
export const ProductFeatureType$inboundSchema: z.ZodNativeEnum<
  typeof ProductFeatureType
> = z.nativeEnum(ProductFeatureType);
/** @internal */
export const ProductFeatureType$outboundSchema: z.ZodNativeEnum<
  typeof ProductFeatureType
> = ProductFeatureType$inboundSchema;
